/* eslint-disable no-return-await */
import {
  GET_SETTINGS,
  ON_SETTINGS_CHANGE,
  IS_APP_LOADING,
  SETTINGS_DATA_URL,
  SETTINGS_PARAMS_URL,
  isSiteMode,
  origCompId,
  compId,
  ON_STYLE_CHANGE,
  ON_SELECTED_CATEGORY,
  GET_FAQ_CONTENT,
} from './utils';

import triggerEvent from '../services/bi/biEditorLogger';
import triggerEventSite from '../services/bi/biSiteLogger';
import biData from '../services/bi/biEvents.json';
import wixService from '../services/wixService';
import httpRequest from './httpRequests';

const ApiSettingsURL = `${SETTINGS_DATA_URL}/api/settings${SETTINGS_PARAMS_URL}&isSite=${isSiteMode}&origCompId=${origCompId}`;
const ApiDeleteURL = `${SETTINGS_DATA_URL}/api/delete${SETTINGS_PARAMS_URL}&isSite=${isSiteMode}&wCompId=${compId}`;
const ApiGetQuestionsURL = `${SETTINGS_DATA_URL}/faqService/getQuestionsByCategoryId${SETTINGS_PARAMS_URL}&isSite=${isSiteMode}&CompId=${compId}`;

export const onSettingsLoad = async (appCompId) => {
  // eslint-disable-next-line no-return-await
  return await getSettingsData(appCompId);
};

export const onStylesChange = (styleParams) => (dispatch) => {
  dispatch({
    type: ON_STYLE_CHANGE,
    payload: styleParams,
  });
};

// api is a customized axios instance
export const getSettingsData = () => async (dispatch) => {
  fetch(`${ApiSettingsURL}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })
    .then(async (res) => {
      const resJson = await res.json();
      return resJson.settings;
    })
    .then((res) => {
      dispatch({
        type: GET_SETTINGS,
        payload: res,
      });
    });
};

export const updateSettings = (settings) => {
  return function (dispatch) {
    dispatch({
      type: ON_SETTINGS_CHANGE,
      payload: settings,
    });
  };
};

export const updateMobileSettings = function (settings) {
  return function () {
    delete settings.previewFirstAnswer;
    fetch(`${ApiSettingsURL}`, {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ settings }),
    })
      .then(async (res) => {
        return await res.json();
      })
      .then(function () {});
  };
};

export const deleteComponent = () => {
  return function () {
    fetch(`${ApiDeleteURL}`, {
      method: 'delete',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(async (res) => {
        console.log('app settings deleted: ', res);
      })
      .then(function (res2) {
        console.log("app settings can't delete: ", res2);
      });
  };
};

export const sitePublishOrSave = (settings, faqList) => {
  return function () {
    const bShowSocialIcons =
      settings.social.facebook &&
      settings.social.twitter &&
      settings.social.linkedin &&
      settings.social.copyQuestionLink;

    const jsonToPublish = {
      wixlabs_string_1: settings.layout, // [Layout] selected layout [collapse / basic / stripes]
      wixlabs_string_2: settings.title.alignment, // -  [Layout] Title alignment =  left / center / right
      wixlabs_bool_1: settings.title.show, // - [Display] show title (Toggle On = true, Toggle Off = false)
      wixlabs_bool_2: settings.searchBar.show, // - [Display] show search bar (Toggle On = true, Toggle Off = false)
      wixlabs_bool_3: bShowSocialIcons, // - [Display] show social icons (true - showing all, false - not showing all) - need to check how it works right now in theold version
      wixlabs_bool_4: settings.openFirstAnswer, // - [Settings] open first answer (Toggle On = true, Toggle Off = false)
      wixlabs_bool_5: settings.isFixedHeight, // - [Layout] app height (True =   choose hight  ; False = auto fit to content)
      wixlabs_bool_6: !settings.isRTL, // - [Settings] alignemnt  (True = left to right ; False = right to left)
      wixlabs_bool_7: false, // - hovered over the "mobile view" in desktop main tab
      wixlabs_bool_8: false, // - opened mobile settings
      wixlabs_bool_9: settings.isDemoFaqData, // - showing demo data (True = yes; False = no)
      wixlabs_bool_10: settings.manageCategories.showAll, // - [Display] show all categries (Toggle On = true, Toggle Off = false)
      wixlabs_bool_11: settings.openOneAnswer, // // - [Settings] show one answer at atime  (Toggle On = true, Toggle Off = false)
      wixlabs_bool_12: settings.isRegularAppSpacing, // - [Layout] - app spacing true = regular, false = compact
      wixlabs_bool_13: settings.seo.settings || false, // - [Settings] - enable SEO  (Toggle On = true, Toggle Off = false)
      wixlabs_bool_14: settings.isArrowExpandIcon, // - [Design] - Expand Icon - true = Arrow, false = Plus
      wixlabs_bool_15: settings.enableScrollAnimation, // - [Settings] enable scroll animation (Toggle On = true, Toggle Off = false)
      wixlabs_num_1: Object.keys(faqList.questions).length, // - number of questions
      wixlabs_num_2: Object.keys(faqList.categories).length, // - number of categories
      wixlabs_num_5: settings.manageCategories.categories.length || 0, // - [Display] number of categories chosen
    };

    triggerEvent({ ...biData.SITE_PUBLISHED, ...jsonToPublish });

    // console.log({settings});
  };
};

export const isAppLoading = function (flag) {
  return {
    type: IS_APP_LOADING,
    isLoading: flag,
  };
};

export const onCategoryChecked = (categoryId, faqList) => (dispatch) => {
  fetch(`${ApiGetQuestionsURL}&categoryId=${categoryId}`).then((res) => {
    res.json().then((questionsRes) => {
      const categoryIndex = faqList.categories.findIndex(
        (cat) => cat.id === categoryId,
      );
      faqList.categories[categoryIndex].questionsList = questionsRes;

      dispatch({
        type: ON_SELECTED_CATEGORY,
        payload: {
          categories: faqList.categories,
          questions: faqList.questions.concat(questionsRes),
        },
      });
    });
  });
};

const getFAQContentParams = (manageCategories) => {
  return {
    manageCategories,
    lang: wixService.getParamFromURL('lang'),
    dateNumberFormat: wixService.getParamFromURL('dateNumberFormat'),
    isPrimaryLanguage: wixService.getParamFromURL('isPrimaryLanguage'),
  };
};

export const getFAQContent = (manageCategories) => (dispatch) => {
  httpRequest.get(
    '/faqContent',
    getFAQContentParams(manageCategories),
    (res) => {
      dispatch({
        type: GET_FAQ_CONTENT,
        payload: res.data,
      });
      const { categories, questions } = res.data;
      biData.APP_LOADED.num_of_questions = Object.keys(questions).length;
      biData.APP_LOADED.num_of_categories = Object.keys(categories).length;
      triggerEventSite(biData.APP_LOADED);
    },
  );
};
